import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import tPsActionCreators from '../../store/training-programs/action-creators';
import tPsSelectors from '../../store/training-programs/selectors';
import CloseActionButton from '../common/CloseActionButton';
import TPForm from './TPForm';

class TrainingProgramEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        description: this.props.trainingProgram.description,
        title: this.props.trainingProgram.title,
      },
    };
  }

  save(formData) {
    const withStatic = { type: this.props.trainingProgram.type };
    this.props.updateTP(this.props.trainingProgram.guid, Object.assign(formData, withStatic));
  }

  render() {
    return (
      <Fragment>
        <TPForm
          initialValues={this.state.initialValues}
          onSave={formData => this.save(formData)}
        />
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return { trainingProgram: tPsSelectors.selectedTP(state) };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeEditTP: () => dispatch(tPsActionCreators.closeEditTP()),
    updateTP: (tPGuid, formData) => {
      return dispatch(tPsActionCreators.updateTP(tPGuid, formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainingProgramEdit);
